import update from 'immutability-helper';
import * as types from './types';

const initialState = {
  sliceFrom: 0,
  sliceTo: 0,
  response: {},
  sliceResponse: null,
  errorCode: 0,
  errorMsg: '',
  isFetching: true,
  invalidResponse: true,
  isSliceFetching: true,
  zoomStart: 0,
  zoomEnd: 0,
  brushStart: 0,
  brushEnd: 0,
  query: {},
};

const switchMap = {};

switchMap[types.INIT] = state => update(state, {
  $set: initialState,
});

switchMap[types.SET_SLICE_INTERVAL] = (state, action) => update(state, {
  $merge: {
    sliceFrom: action.from,
    sliceTo: action.to,
  },
});

switchMap[types.SET_BIRD_CHART_STATE] = (state, action) => update(state, {
  $merge: action.state,
});

switchMap[types.RESET_SLICE_INTERVAL] = state => update(state, {
  $merge: {
    sliceFrom: 0,
    sliceTo: 0,
    zoomStart: 0,
    zoomEnd: 0,
    brushStart: 0,
    brushEnd: 0,
    invalidResponse: true,
    sliceResponse: null,
    isSliceFetching: true,
  },
});

switchMap[types.SET_ZOOM_RANGE] = (state, action) => update(state, {
  $merge: {
    zoomStart: action.zoomStart,
    zoomEnd: action.zoomEnd,
  },
});

switchMap[types.SET_BRUSH_RANGE] = (state, action) => update(state, {
  $merge: {
    brushStart: action.brushStart,
    brushEnd: action.brushEnd,
  },
});


switchMap[types.FETCHING] = state => update(state, {
  isFetching: {
    $set: true,
  },
});

switchMap[types.FETCHING_SUCCESS] = (state, action) => update(state, {
  $merge: {
    response: action.response,
    isFetching: false,
    errorCode: 0,
    errorMsg: '',
    invalidResponse: false,
  },
});

switchMap[types.FETCHING_FAILS] = (state, action) => update(state, {
  $merge: {
    response: null,
    isFetching: false,
    errorCode: action.errorCode || 500,
    errorMsg: action.errorMsg || 'Unknown error.',
    invalidResponse: false,
  },
});

switchMap[types.FETCHING_SLICE] = state => update(state, {
  isSliceFetching: {
    $set: true,
  },
});

switchMap[types.FETCHING_SLICE_SUCCESS] = (state, action) => update(state, {
  $merge: {
    isSliceFetching: false,
    sliceResponse: action.sliceResponse,
  },
});

switchMap[types.FETCHING_SLICE_FAILS] = (state, action) => update(state, {
  $merge: {
    response: null,
    isSliceFetching: false,
    errorCode: action.errorCode || 500,
    errorMsg: action.errorMsg || 'Unknown error.',
  },
});

switchMap[types.RESET_RESPONSE] = state => update(state, {
  $merge: {
    response: null,
    invalidResponse: true,
  },
});

switchMap[types.SET_INVALID_RESPONSE] = (state, action) => update(state, {
  invalidResponse: {
    $set: action.invalidResponse,
  },
});

switchMap[types.SAVE_BIRD_CHART_QUERY] = (state, action) => update(state, {
  query: {
    $set: action.body,
  },
});

switchMap[types.SAVE_ZOOM_INTERVAL] = (state, action) => update(state, {
  $merge: {
    zoomIntervalStart: action.zoomIntervalStart,
    zoomIntervalEnd: action.zoomIntervalEnd,
  },
});

export default (state = initialState, action) => (
  switchMap[action.type]
    ? switchMap[action.type](state, action)
    : state
);
